"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RouteTabs_1 = require("./RouteTabs");
exports.default = RouteTabs_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/RouteTabs/index.js
// module id = 1264
// module chunks = 8